import React from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

function Card({ onChartCreator }) {
    return (
        <TransitionGroup component={null}>
            <CSSTransition timeout={{ enter: 300, exit: 0 }} classNames="fade-frame">
                <iframe src={onChartCreator()} title="TradeChart" width="100%" height="475" frameBorder="0" />
            </CSSTransition>
        </TransitionGroup>
    );
}
export default Card;
